import { render, staticRenderFns } from "./PItemRow4.vue?vue&type=template&id=7508f972"
import script from "./PItemRow4.vue?vue&type=script&lang=js"
export * from "./PItemRow4.vue?vue&type=script&lang=js"
import style0 from "./PItemRow4.vue?vue&type=style&index=0&id=7508f972&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports